import {XApplication} from './XApplication';
import {XMainForm} from './components/forms/XMainForm';
import {XHStack} from './XHStack';
import {XVStack} from './XVStack';
import {XImageLink} from './XImageLink';
import {XStub} from './XStub';
import {XTable, XTableRow, XTableCell} from './XTable';
import {XSeek} from './XSeek';
import {XBigButton} from './XBigButton';
import {XButtonsLine} from './XButtonsLine';
import {XContentForm} from './XContentForm';
import {XArticle} from './components/containers/XArticle';
import {XArticleSticker} from './components/containers/XArticleSticker';
import {XFrame} from './components/containers/XFrame';
import {XKanban} from './components/kanban/XKanban';
import {XPanel} from './components/containers/XPanel';
import {XTextEdit} from './components/basics/XTextEdit';
import {XWindow} from './components/windows/XWindow';
import {XColumn} from './components/layouts/XColumn';
import {XRow} from './components/layouts/XRow';
import {XPaletteItem} from './XPaletteItem';
import {XPalette} from './XPalette';
import {XTabPanel, XTabBar, XTab} from './components/containers/XTabPanel';



//declare const X: string;
//export as namespace X;
/*export default {
    //Application,
    MainForm,
    HStack,
    VStack,
    ImageLink,
    Stub,
    Table,
    TableRow,
    TableCell,
    Seek,
    Button,
    ButtonsLine,
    ContentForm,
    Article,
    Frame
}*/
//export {XApplication} from './XApplication';
/*declare module "X" {
    namespace X {

    }
    export = X;
}*/
export declare namespace X {
    export {
        XApplication,
        XMainForm,
        XHStack,
        XVStack,
        XImageLink,
        XStub,
        XTable,
        XTableRow,
        XTableCell,
        XSeek,
        XBigButton,
        XButtonsLine,
        XContentForm,
        XArticle,
        XFrame,
        XKanban,
        XPanel,
        XTextEdit,
        XWindow,
        XColumn,
        XRow,
        XPaletteItem,
        XPalette,
        XTabPanel,
        XTabBar,
        XTab,
    };    
}
//export const X: typeof X = X;
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default{
    XApplication,
    XMainForm,
    XHStack,
    XVStack,
    XImageLink,
    XStub,
    XTable,
    XTableRow,
    XTableCell,
    XSeek,
    XBigButton,
    XButtonsLine,
    XContentForm,
    XArticle,
    XFrame,
    XKanban,
    XPanel,
    XArticleSticker,
    XTextEdit,
    XWindow,
    XColumn,
    XRow,
    XPaletteItem,
    XPalette,
    XTabPanel,
    XTabBar,
    XTab,

};
//export default X;

